import { SwalMessage } from '../Tools'

// yazı sayfa işlemleri
var Article = function () {

    var form;

    // Yorum
    var Comment = function () {

        let commentForm = form.querySelector('.comment-form')
        if (!commentForm) {
            return;
        }

        // yıldız oylama
        $(commentForm).on('click', '.stars .fa-star', function () {
            $('.stars .selected').each(function () {
                $(this).removeClass('selected');
            });
            $(this).addClass('selected');

            let voting = $(this).attr('data-voting')

            commentForm.querySelector('input[name="voting"]').value = voting
        });

        // form gönder
        // ürün yorum ve yazı yorum formu gönderir
        $(commentForm).on('click', '[data-article-comment-submit]', function (event) {
            event.preventDefault();

            let formAction = commentForm.querySelector('form')

            $.ajax({
                url: apiUrl + '/CreateArticleComment',
                type: "POST",
                dataType: "json",
                data: $(formAction).serialize(),
                error: function error(xhr) {
                    $(formAction).find('.invalid-feedback').empty();
                    $(formAction).find('*').removeClass('is-invalid');
                    $.each(xhr.responseJSON.errors, function (name, message) {

                        let element = formAction.querySelector('[name="' + name + '"]')

                        element.classList.add('is-invalid')

                        let valid = element.closest('div')
                            .querySelector('.invalid-feedback');
                        valid.style.display = 'block'
                        valid.innerHTML = message;

                    });
                },
                success: function success(xhr) {
                    SwalMessage(
                        {
                            type: 'success',
                            text: xhr.text ?? xhr.message,
                            confirmButton: translate.ok_button,
                        },
                        function () {
                            location.reload();
                        }
                    );
                }
            });


        })

    }

    return {
        init: function () {
            form = document.querySelector('.article-page')
            if (form) {
                Comment();
            }

        },
    };

}();




$(function () {
    Article.init();
});